import classNames from 'classnames';

import Content from './Content';

const className = ({className, isCurrent, isAvailable, isAirport, focus}) => classNames(className, {
    current: isCurrent,
    available: isAvailable,
    airport: isAirport,
    focus,
});

const Item = ({onClick, ...props}) => (
    <li className={className(props)} onClick={onClick}>
        <Content {...props} />
    </li>
);

export default Item;
